"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.wrapPageElement = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _gatsby = require("gatsby");
var _browserLang = _interopRequireDefault(require("browser-lang"));
var _LocaleProvider = require("./LocaleProvider");
var _options = require("./options");
var isRedirect = false;
var getLocaleForPage = function getLocaleForPage(props) {
  var _props$path;
  var pageContext = props.pageContext;
  if (pageContext !== null && pageContext !== void 0 && pageContext.locale) {
    return pageContext === null || pageContext === void 0 ? void 0 : pageContext.locale;
  }
  var splittedPath = props === null || props === void 0 ? void 0 : (_props$path = props.path) === null || _props$path === void 0 ? void 0 : _props$path.split('/');

  // Prevent issue with applepay/conditions page redirect
  if (splittedPath.length < 3) {
    return undefined;
  }
  var locale = splittedPath[1];
  return ['en', 'fr', 'nl'].includes(locale) ? locale : _options.defaultLang;
};
var wrapPageElement = exports.wrapPageElement = function wrapPageElement(_ref) {
  var element = _ref.element,
    props = _ref.props;
  if (typeof window !== 'undefined') {
    var detectedLanguage = (0, _browserLang.default)({
      languages: (0, _options.getLanguages)(),
      fallback: _options.defaultLang
    });
    if (!isRedirect) {
      if (!props || !props.pageContext || !props.pageContext.locale) {
        if (window.location.href.indexOf('404') !== -1) {
          (0, _gatsby.navigate)((_options.urlPrefixPath ? "/" + _options.urlPrefixPath : '') + ("/" + detectedLanguage));
        }
      }
    }
  }
  var pageContext = (0, _extends2.default)({}, props.pageContext, {
    locale: getLocaleForPage(props)
  });
  return /*#__PURE__*/_react.default.createElement(_LocaleProvider.LocaleProvider, {
    pageContext: pageContext
  }, element);
};